module.exports = __webpack_public_path__ + "img/CalendarIcon.460a1ca3.svg";